import { c as _c } from "react-compiler-runtime";
import * as React from "react";
import { ComboBox as AriaComboBox, ComboBoxStateContext, Input as AriaInput, InputContext, LabelContext, useSlottedContext } from "react-aria-components";
import { ListBox } from "./ListBox.js";
import { Popover } from "./Popover.js";
import { Spinner } from "./Spinner.js";
import { ChevronButton } from "./shared/ChevronButton.js";
import { ClearButton } from "./shared/ClearButton.js";
import ErrorIcon from "./shared/ErrorIcon.js";
import { InputBuilder } from "./shared/InputBuilder.js";
import { extractInputBuilderProps } from "./shared/inputBuilderHelper.js";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function RightIcons(t0) {
  const $ = _c(7);
  const {
    isError,
    isOpen,
    loadingState,
    loadingRenderState,
    loadingStartAnimation
  } = t0;
  const selectionState = React.useContext(ComboBoxStateContext);
  if (isError && !isOpen || isError && isOpen && selectionState?.selectedKey == null) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = /*#__PURE__*/_jsx(ErrorIcon, {});
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] !== loadingRenderState || $[2] !== loadingStartAnimation || $[3] !== loadingState) {
    t1 = loadingState == null ? null : /*#__PURE__*/_jsx(Spinner, {
      state: loadingState,
      renderState: loadingRenderState,
      startAnimation: loadingStartAnimation,
      size: "s",
      color: "royalBlue"
    });
    $[1] = loadingRenderState;
    $[2] = loadingStartAnimation;
    $[3] = loadingState;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = /*#__PURE__*/_jsx(_Fragment, {
      children: t1
    });
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}
export function ComboBox(t0) {
  const $ = _c(27);
  let children;
  let placeholder;
  let props;
  let t1;
  let t2;
  let title;
  if ($[0] !== t0) {
    ({
      children,
      placeholder,
      title,
      clearButton: t1,
      virtualized: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = placeholder;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
    $[6] = title;
  } else {
    children = $[1];
    placeholder = $[2];
    props = $[3];
    t1 = $[4];
    t2 = $[5];
    title = $[6];
  }
  const clearButton = t1 === undefined ? false : t1;
  const virtualized = t2 === undefined ? false : t2;
  const ref = React.useRef(null);
  let t3;
  if ($[7] !== props) {
    t3 = extractInputBuilderProps(props);
    $[7] = props;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const {
    inputBuilderProps,
    restProps
  } = t3;
  const labelProps = useSlottedContext(LabelContext);
  const inputProps = useSlottedContext(InputContext);
  const t4 = labelProps?.id ?? undefined;
  let t5;
  if ($[9] !== clearButton) {
    t5 = state => /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(RightIcons, {
        ...state
      }, "icon"), /*#__PURE__*/_jsx(ClearButton, {
        clearButton: clearButton
      }, "clear"), /*#__PURE__*/_jsx(ChevronButton, {}, "chevron")]
    });
    $[9] = clearButton;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const t6 = inputProps?.id ?? undefined;
  let t7;
  if ($[11] !== placeholder || $[12] !== t6 || $[13] !== title) {
    t7 = /*#__PURE__*/_jsx(AriaInput, {
      id: t6,
      title: title,
      placeholder: placeholder
    });
    $[11] = placeholder;
    $[12] = t6;
    $[13] = title;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== inputBuilderProps || $[16] !== t5 || $[17] !== t7) {
    t8 = /*#__PURE__*/_jsx(InputBuilder, {
      ref: ref,
      ...inputBuilderProps,
      right: t5,
      children: t7
    });
    $[15] = inputBuilderProps;
    $[16] = t5;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== children || $[20] !== virtualized) {
    t9 = /*#__PURE__*/_jsx(Popover, {
      triggerRef: ref,
      width: "triggerRef",
      children: /*#__PURE__*/_jsx(ListBox, {
        virtualized: virtualized,
        children: children
      })
    });
    $[19] = children;
    $[20] = virtualized;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== restProps || $[23] !== t4 || $[24] !== t8 || $[25] !== t9) {
    t10 = /*#__PURE__*/_jsxs(AriaComboBox, {
      "aria-labelledby": t4,
      menuTrigger: "focus",
      ...restProps,
      children: [t8, t9]
    });
    $[22] = restProps;
    $[23] = t4;
    $[24] = t8;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  return t10;
}
//# sourceMappingURL=ComboBox.js.map